// extracted by mini-css-extract-plugin
var _1 = "src-js-components-iconCircle--IconCircle-modules__iconCircle";
export { _1 as "iconCircle" }
